import React, { Component } from 'react';
import ButtonComponent from 'components/controls/Button';
import _StudentService from '../../modules/StudentService';
import { Spin } from 'antd';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { PROJECT_LOGO } from '../../constants/constants';
import _branding from 'modules/branding';
import _utils from '../../modules/Utils';
// Phase C.5 (Candidate System UI Language Migration) migrated the page chrome OUTSIDE the printable
// Hall Ticket payload. The "Admit Card / Hall Ticket Standardization, Center Binding & Language Fix"
// phase migrated the printable payload itself (#outerBorder/#divReceiptPrint below) too, and fixed the
// EXAM CENTRE DETAILS block to also render the configured Center Name (previously CenterAddress only)
// — see modules/i18n/pages/examCard.js for the terminology-freeze/localization rationale.
import Text from 'components/Text/Text';
class ExamCard extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            data: [],
            posts: [],
            loading: true,
            studentPersonalModel: {},
            challanBankDetailModel: {},
            studentReservationModel: {},
            isLoading: false
        };
    }


    componentDidMount() {
        this.getStudentPersonalData();
    }

    getStudentPersonalData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let response = await _StudentService.getStudentReceiptData();
                    this.setState({
                        data: response.data,
                        // applicationId : response.data.Application_Id,
                        studentPersonalModel: response.data.studentPersonalModel,
                        challanBankDetailModel: response.data.challanBankDetailModel,
                        studentReservationModel: response.data.studentReservationModel,
                        otherInformationModel: response.data.otherInformationModel,
                        loading: false
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onPrint = () => {
        this.setState({ isLoading: true });
        window.scrollTo(0, 0);
        const originalDiv = document.querySelector("#divReceiptPrint");

        // Clone the div to avoid modifying the original
        const clonedDiv = originalDiv.cloneNode(true);
        clonedDiv.style.position = "absolute";
        clonedDiv.style.left = "-9999px";
        clonedDiv.style.width = "1400px";
        document.body.appendChild(clonedDiv);


        html2canvas(clonedDiv, {
            scale: 3, allowTaint: true, useCORS: true
        }).then(canvas => {
            const imgData = canvas.toDataURL('image/jpeg', 0.8);

            const doc = new jsPDF({
                orientation: 'p',
                unit: 'pt',
                format: 'a4',
                compressPdf: true
            });

            const pageWidth = 595.28;
            const pageHeight = 841.89;

            const margin = 1; // Margin for all sides
            const contentWidth = pageWidth - margin * 2;
            const contentHeight = pageHeight - margin * 2;

            const widthRatio = contentWidth / canvas.width;
            const heightRatio = contentHeight / canvas.height;
            const ratio = Math.min(widthRatio, heightRatio);

            const canvasWidth = canvas.width * ratio;
            const canvasHeight = canvas.height * ratio;

            // Center the image within the margins
            const xOffset = margin + (contentWidth - canvasWidth) / 2;
            const yOffset = margin;

            doc.addImage(imgData, 'JPEG', xOffset, yOffset, canvasWidth, canvasHeight);
            doc.save(_utils.buildHallTicketFileName(this.state.data.studentPersonalModel));
            document.body.removeChild(clonedDiv);
            this.updateExamCardDownloadStatus();
        });
    }

    updateExamCardDownloadStatus = async () => {
        try {
            let response = await _StudentService.UpdateStudentExamCardDownloadFlag(true);
        } catch (e) {
            console.log('Error: ', e);
        }
        this.setState({ isLoading: false });
    }

    onCancel = () => {
        this.props.onTabOrderChange(-1);
    }

    render() {
        if (this.state.loading)
            return <div role="status" aria-live="polite"><Spin size="large" /></div>

        return (
            <>
                <div className="cd-priview printPage cd-card gl-bxbr analysisWrap p-4 mt-4 ch-container">
                    <h4 className="ch-heading4 mb-4"><Text k="examCard.pageHeading" /></h4>
                    <div className="cd-priview-wrap">
                        <div className="candidateform-cover pt-3 pr-3 pl-3 pb-2">
                            <div id="outerBorder" style={{ textAlign: 'center', border: 'solid', borderColor: 'gray' }}>
                                <div id="divReceiptPrint" style={{ textAlign: 'center', border: 'solid', borderColor: 'transparent', padding: 7 }}>
                                    <div>
                                        {/* Phase C.7.2 (Branding Foundation): resolved through the unified priority chain
                                            (Portal_Logo → branding LogoUrl → PROJECT_LOGO) instead of a hardcoded env-config logo. */}
                                        <img alt='headerLogo' src={_branding.resolveLogoUrl(localStorage['Portal_Logo'], PROJECT_LOGO)} className='projectLogoSizeWidth' style={{ alignSelf: 'center', cursor: "pointer" }} />
                                    </div>

                                    <div
                                        className="heading admitCardTxtAlign1"
                                        style={{
                                            fontSize: "25px",
                                            fontWeight: "bold",
                                            marginTop: "5px",
                                            marginBottom: "5px",
                                            color: "black",
                                            width: "100%"
                                        }}
                                    >{this.state.data.studentPersonalModel.Applied_Post}</div>
                                    <h5 className="heading admitCardTxtAlign"><Text k="examCard.documentTitle" /></h5>

                                    <div className="receipt_generation_Table1 my-2" style={{ width: '100%' }}>
                                        <table className='table_100_percent tableHiddenBorder'>
                                            <tbody>
                                                <tr>
                                                    <td className='table_personal_info' style={{ padding: 0, borderStyle: 'hidden' }}>
                                                        <table style={{ width: '100%' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <th className='width_25_Percent'>
                                                                        <Text k="examCard.candidateFullNameLabel" />
                                                                    </th>
                                                                    <td colSpan={2}>{(this.state.data.studentPersonalModel.First_Name) + ' ' +
                                                                        (this.state.data.studentPersonalModel.Middle_Name) + ' ' +
                                                                        (this.state.data.studentPersonalModel.Last_Name)}
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ height: '25px' }}>
                                                                    <th>
                                                                        <Text k="examCard.formNoLabel" />
                                                                    </th>
                                                                    <td>{this.state.data.studentPersonalModel.Form_Number}</td>

                                                                    <th rowSpan={4} className='examCardImgWidths' style={{ textAlign: '-webkit-center' }}>
                                                                        <td>
                                                                            <img className='recDetailsProfileImg' src={this.state.data.studentPersonalModel.Profile_Pic_Path} alt="Profile" />
                                                                        </td>
                                                                    </th>
                                                                </tr>
                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.rollNumberUserNameLabel" />
                                                                    </th>
                                                                    <td>{this.state.data.studentPersonalModel.Roll_Number}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.dateOfBirthLabel" />
                                                                    </th>
                                                                    <td>{moment(this.state.data.studentPersonalModel.Birth_Date).format('DD-MMM-YYYY')}</td>
                                                                </tr>

                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.genderLabel" />
                                                                    </th>
                                                                    <td>{this.state.data.studentPersonalModel.Gender}</td>
                                                                </tr>

                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.disabilityCategoryNameLabel" />
                                                                    </th>
                                                                    <td className='displayInRight' >{this.state.data.studentPersonalModel.DisabilityCategoryName ?
                                                                        this.state.data.studentPersonalModel.DisabilityCategoryName
                                                                        : "N/A"}
                                                                    </td>

                                                                    <th rowSpan={2} className='examCardImgWidths'>
                                                                        <td>
                                                                            <img className='receDetailsSignatureImg' src={this.state.data.studentPersonalModel.Signature_Path} alt="Signature" />
                                                                        </td>

                                                                        <div className='displayInGrid f-12'>
                                                                            <Text k="examCard.signatureOnApplicationFormLabel" />
                                                                        </div>
                                                                    </th>
                                                                </tr>
                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.isScribeRequiredLabel" />
                                                                    </th>
                                                                    <td>{this.state.data.studentPersonalModel.IsScribeRequired ? "Yes" : "No"}</td>
                                                                </tr>

                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.examDateLabel" />
                                                                    </th>
                                                                    <td>{moment(this.state.data.studentPersonalModel.Exam_Date).isValid() ? moment(this.state.data.studentPersonalModel.Exam_Date).format("DD-MMM-YYYY") : ''}</td>

                                                                    <th rowSpan={2} className='examCardImgWidths'>
                                                                        <div className='borderBlack signatureBoxAlign'>
                                                                        </div>

                                                                        <div className='displayInGrid f-12'>
                                                                            <div><Text k="examCard.signatureInvigilatorLine1" /></div>
                                                                            <div><Text k="examCard.signatureInvigilatorLine2" /></div>
                                                                        </div>
                                                                    </th>
                                                                </tr>

                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.examTimeLabel" />
                                                                    </th>
                                                                    <td>{this.state.data.studentPersonalModel.Exam_Time}</td>
                                                                </tr>

                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.reportingTimeLabel" />
                                                                    </th>
                                                                    <td>
                                                                        <Text k="examCard.reportingTimeNote" />
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.gateClosureTimeLabel" />
                                                                    </th>
                                                                    <td>
                                                                        <Text k="examCard.gateClosureNote" />
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <th>
                                                                        <Text k="examCard.examCentreDetailsLabel" />
                                                                    </th>
                                                                    <td colSpan={2}>
                                                                        {this.state.data.studentPersonalModel.CenterName}<br />
                                                                        {this.state.data.studentPersonalModel.CenterAddress}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className='admitCardIdPassAlign'>
                                            <div className='displayFlex' style={{ marginRight: "15px", fontSize: "14px", fontWeight: "bold" }}><Text k="examCard.usernameRollNumberLabel" /></div>
                                            <div style={{ marginRight: "auto", fontSize: "14px", fontWeight: "bold" }}>{this.state.data.studentPersonalModel.Roll_Number}</div>
                                            <div className='displayFlex' style={{ marginRight: "15px", fontSize: "14px", fontWeight: "bold" }}><Text k="examCard.passwordLabel" /></div>
                                            <div style={{ marginRight: "15px", fontSize: "14px", fontWeight: "bold" }}>{this.state.data.studentPersonalModel.Mobile_Number}</div>
                                        </div>

                                        <div className='page-break ' style={{ pageBreakBefore: 'always' }}></div>
                                        <div className='impInstrAlign1 '>
                                            <div className='impInst1Title'><Text k="examCard.importantNoteHeading" /></div>
                                            <p className='mb7'><span>&bull;</span><span className='ml15'><Text k="examCard.colorPrintNote" /></span></p>
                                            <p className='mb7'><span>&bull;</span><span className='ml15'><Text k="examCard.invigilatorAuthorityNote" /></span></p>
                                            <p className='displayFlex mb0'>
                                                <span>&bull;</span>
                                                <span className='ml15 displayFlex'><Text k="examCard.roughSheetNote" /></span>
                                            </p>
                                        </div>

                                        <label className='instrLabel' style={{ marginTop: "40px", fontSize: "20px", marginBottom: "20px" }}><Text k="examCard.importantInstructionsHeading" /></label>
                                        <div className='examcard_note1'>
                                            <div className='displayFlex mb7'>
                                                <span className='mr30'>1)</span>
                                                <span><Text k="examCard.instruction1" /></span>
                                            </div>

                                            <div className='displayFlex mb7 fBold'>
                                                <span className='mr30'>2)</span>
                                                <span><Text k="examCard.instruction2" /></span>
                                            </div>

                                            <div className='displayFlex mb7 fBold'>
                                                <span className='mr30'>3)</span>
                                                <span><Text k="examCard.instruction3" /></span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr30'>4)</span>
                                                <span><Text k="examCard.instruction4" /></span>
                                            </div>

                                            <div className='displayFlex mb7 fBold'>
                                                <span className='mr30'>5)</span>
                                                <span><Text k="examCard.instruction5" /></span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr30'>6)</span>
                                                <span><Text k="examCard.instruction6" />
                                                    <div><Text k="examCard.instruction6a" /></div>
                                                    <div><Text k="examCard.instruction6b" /></div>
                                                    <div><Text k="examCard.instruction6c" /></div>
                                                </span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr30'>7)</span>
                                                <span><Text k="examCard.instruction7" />
                                                    <div><Text k="examCard.instruction7a" /></div>
                                                    <div><Text k="examCard.instruction7b" /></div>
                                                </span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr30'>8)</span>
                                                <span><Text k="examCard.instruction8" /></span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr30'>9)</span>
                                                <span><Text k="examCard.instruction9" /></span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr20'>10)</span>
                                                <span><Text k="examCard.instruction10" /></span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr20'>11)</span>
                                                <span><Text k="examCard.instruction11" /></span>

                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr20'>12)</span>
                                                <span><Text k="examCard.instruction12" /></span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr20'>13)</span>
                                                <span><Text k="examCard.instruction13" /></span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr20'>14)</span>
                                                <span><Text k="examCard.instruction14" /></span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr20'>15)</span>
                                                <span><Text k="examCard.instruction15" /></span>
                                            </div>

                                            <div className='displayFlex mb7'>
                                                <span className='mr20'>16)</span>
                                                <span><Text k="examCard.instruction16" /></span>
                                            </div>

                                            <div className='displayFlex mb7 fBold'>
                                                <span className='mr20'>17)</span>
                                                <span><Text k="examCard.instruction17" /></span>
                                            </div>

                                            <div className='displayFlex mb7 fBold'>
                                                <span className='mr20'>18)</span>
                                                <span><Text k="examCard.instruction18" /></span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="form-action d-flex justify-content-end button-global-group btn3">
                                    <div className="btn2-wrap mb-0">
                                        <ButtonComponent
                                            id="btnCancel"
                                            type="button"
                                            value={<div className='displayInGrid'><Text k="challanDetails.cancelButton" /></div>}
                                            className="button-global button-border mr-4 autoHeight"
                                            onClick={this.onCancel}
                                        />

                                    </div>

                                    <ButtonComponent
                                        id="btnSubmit"
                                        type="button"
                                        value={<div className='displayInGrid'><Text k="examCard.printDownloadButton" /></div>}
                                        className="button-global button-secondary autoHeight"
                                        onClick={this.onPrint}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.isLoading && <div role="status" aria-live="polite"><Spin size="large" /></div>}
                </div>

            </>
        )
    };
}

export default ExamCard;
